import React, { useEffect, useState } from "react";
import { debounce } from "../../helpers/helpers";

const findIndex = (selected, items) => {
  if (!selected) return 0;
  // если не нашли, берем ближайший наибольший
  const index = items.findIndex(
    (i) =>
      i.number >= selected.number &&
      (!i.periodTypeId || selected.periodTypeId === i.periodTypeId)
  );

  // если такого элемента нет, выбираем первый
  return index < 0 ? 0 : index;
};

// чтобы debounc'ить независимо от рендера компоненты
const debounced = debounce();

export const CalcRangeSelector = ({ selected, items, onSelect, onChange }) => {
  const [index, setIndex] = useState(findIndex(selected, items));

  // пользовательское изменение значения в поле
  const onInputChange = (i) => {
    setIndex(i);
    if (onChange) onChange(items[i]);
  };

  // отправка выбранного значения
  const select = (item) => {
    if (!item) return;
    onSelect(item);
  };

  // слушаем внешние изменения и меняем значение, если оно поменялось
  useEffect(() => {
    const newIndex = findIndex(selected, items);
    if (index !== newIndex) setIndex(newIndex);
  }, [selected]);

  return (
    <input
      type="range"
      onChange={(e) => onInputChange(Number(e.target.value))}
      value={index}
      step={1}
      min={0}
      max={items.length - 1}
      onMouseUp={() => select(items[index])}
      onKeyUp={() => debounced(() => select(items[index]))}
      onTouchEnd={() => select(items[index])}
    />
  );
};
